const $ = window.jQuery;
const AJAX = window.AJAX;

export default class Forms {
	constructor() {
		if (!$ || !AJAX) {
			return;
		}

		this.selectors = {
			find_domain: $('#find_domain'),
			form_mail: $('#form_mail'),
			support_form: $('#support_form'),
			search_result: $('.search_result'),
			form_mail_thank_you: $('#form_mail_thank_you'),
			form_mail_fail: $('#form_mail_failed'),
			domain_input: $('#domain'),
			tld_select: $('#tld'),
			phone_input: $('#phone'),
			reseller_enquiry_block: $('#form_block'),
			error_block: $('#error_block'),
			body: $('body')
		};

		this.urls = {
			find_my_domain_taken_block: 'https://www.whoismydomain.com.au/results/?search=',
			register_domain_block: 'http://www.crazydomains.com.au/domain-names/search/?domain='
		};

		this.classes = {
			loading: '_loading',
			hide: '_hide'
		};

		this.submitted = false;

		this.listeners();
	}

	listeners() {
		this.selectors.find_domain.on('submit', this.searchForm.bind(this));

		this.selectors.form_mail.on('submit', this.dataForm.bind(this));

		this.selectors.support_form.on('submit', this.dataForm.bind(this));

		this.selectors.domain_input.on('input', () => {
			this.selectors.search_result.addClass(this.classes.hide);
		});

		this.selectors.tld_select.on('change', () => {
			this.selectors.search_result.addClass(this.classes.hide);
		});

		this.selectors.phone_input.on('input change', event => {
			const val = event.target.value;

			if (val.indexOf(' ') !== -1) {
				event.target.value = val.replace(/\s+/g, '');
			}
		});
	}

	searchForm(event) {
		event.preventDefault();

		this.sendAjax($(event.target), response => {
			if (typeof response === 'undefined') {
				return;
			}

			if (!response.status) {
				console.log(response.message);
				return;
			}

			if (!response.data || !response.data.block) {
				return;
			}

			const {domain, block} = response.data;
			const el = document.getElementById(block);
			const url = this.urls[block];

			this.selectors.search_result.addClass(this.classes.hide);
			el.classList.remove(this.classes.hide);

			if (url) {
				el.getElementsByClassName('link')[0].href = `${url}${domain}`;
			}

			if (window.mobilecheck()) {
				this.selectors.body.animate({scrollTop: this.selectors.find_domain.offset().top - 20});
			}
		});
	}

	dataForm(event) {
		event.preventDefault();

		this.sendAjax($(event.target), response => {
			if (typeof response === 'undefined') {
				return;
			}

			const {hide} = this.classes;

			this.selectors.reseller_enquiry_block.addClass(hide);

			if (!response.status) {
				this.selectors.form_mail_thank_you.addClass(hide);
				this.selectors.form_mail_fail.removeClass(hide);
				return;
			}

			this.selectors.form_mail_fail.addClass(hide);
			this.selectors.form_mail_thank_you.removeClass(hide);
		});
	}

	sendAjax(form, callback) {
		const {loading, hide} = this.classes;

		if (this.submitted) {
			return callback();
		}

		AJAX.send({
			url: form.attr('action'),
			type: form.attr('method'),
			validation: form[0],
			data: form.serialize(),
			beforeSend: () => {
				this.submitted = true;
				form.find('[type="submit"]').addClass(loading);
			},
			complete: () => {
				this.submitted = false;
				form.find('[type="submit"]').removeClass(loading);
			},
			error: () => {
				this.selectors.error_block.removeClass(hide);
			},
			callback: callback
		});
	}
}



// WEBPACK FOOTER //
// ./src/js/_forms.js